import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { verifiers, selectors, constants } from '@yola/subscription-manager-js';
import redirectToUrl from 'src/js/utils/redirect-to-url';
import segment from '../../modules/analytics/segment';
import { premiumFeatures } from '../../modules/common/constants/premium-features';
import DashboardPageContainer from '../../modules/dashboard/containers/dashboard-page-container';
import useSupportedSearchParams from '../hooks/use-supported-search-params';
import routesMap from '../helpers/routes-map';
import generatePaymentUrl from '../../modules/webapp-plugins/utils/generate-payment-url';
import user from '../../modules/user';
import dialogs from '../../modules/dialogs';

const {
  constants: { triggerIds },
} = segment;
const { DOMAIN_SUBSCRIPTION } = constants.SubscriptionType;

const DashboardRoute = () => {
  const activeHostingSubscription = useSelector(selectors.getActiveHostingSubscription);
  const isB2C = useSelector(user.selectors.getIsB2C);

  const searchParams = useSupportedSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (!searchParams) return null;

  const { products = [], term, domain, premiumFeature } = searchParams;
  const hasProducts = Boolean(products.length);

  if (domain) {
    if (activeHostingSubscription) {
      dispatch(dialogs.actions.show(dialogs.dialogTypes.PENDING));
      redirectToUrl(
        generatePaymentUrl(
          {
            products: [DOMAIN_SUBSCRIPTION],
            domain_name: domain,
          },
          isB2C
        )
      );
      return null;
    }

    navigate(
      routesMap.paywall.url({
        query: {
          domain,
          premiumFeature: premiumFeatures.CUSTOM_DOMAIN,
          triggerId: triggerIds.REDIRECT,
        },
      })
    );

    return null;
  }

  if (hasProducts) {
    const isPaidHostingSubscription = verifiers.hasPaidHostingPackageType(products);
    const query = {
      products,
      term,
      triggerId: triggerIds.REDIRECT,
      ...(premiumFeature && { premiumFeature }),
    };
    const urlToRedirect = isPaidHostingSubscription
      ? routesMap.domainSelector.url({ query })
      : routesMap.paywall.url({ query });

    navigate(urlToRedirect);

    return null;
  }

  return <DashboardPageContainer />;
};

export default DashboardRoute;
